export default __webpack_public_path__ + "static/media/casey-bio-pic.a44530b5.jpg";